export const parseHoursString = (hoursString) => {
    const timeParts = hoursString.split(":")
    const hour = timeParts[0]
    const minutes = timeParts[1]
    const hourRenamed = hour > 12 ? hour - 12 : hour < 1 ? 12 : hour
    const meridian = hour > 11 ? "PM" : "AM"
    // return hoursString
    return `${hourRenamed}:${minutes} ${meridian}`
}
